// Écran ouvert quand le commerçant scanne la carte Wallet d'un client : /t/:clientId
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { supabase } from './supabase'
import { ajouterTampon, donnerRecompense, CORAL, CHARBON, SABLE } from './actions'

export default function Tampon({ session }) {
  const { clientId } = useParams()
  const [client, setClient] = useState(null)
  const [objectif, setObjectif] = useState(10)
  const [recompense, setRecompense] = useState('')
  const [nomCommerce, setNomCommerce] = useState('')
  const [etat, setEtat] = useState('chargement') // chargement | pret | ajoute | introuvable
  const [occupe, setOccupe] = useState(false)
  const [erreur, setErreur] = useState('')

  useEffect(() => {
    async function charger() {
      const [{ data: c }, { data: commerce }] = await Promise.all([
        supabase.from('clients').select('id, nom, tampons').eq('id', clientId).maybeSingle(),
        supabase.from('commerces').select('nom, objectif_tampons, recompense').eq('id', session.user.id).maybeSingle(),
      ])
      setNomCommerce(commerce?.nom || '')
      if (!c) { setEtat('introuvable'); return }
      setClient(c)
      setObjectif(commerce?.objectif_tampons || 10)
      setRecompense(commerce?.recompense || 'Récompense')
      setEtat('pret')
    }
    charger()
  }, [clientId, session.user.id])

  async function plusUn() {
    setOccupe(true); setErreur('')
    try {
      const n = await ajouterTampon(client, session.user.id)
      setClient({ ...client, tampons: n })
      setEtat('ajoute')
    } catch (err) {
      console.error(err)
      setErreur("Le tampon n'a pas pu être ajouté. Réessaie.")
    }
    setOccupe(false)
  }

  async function recompenseDonnee() {
    setOccupe(true); setErreur('')
    try {
      await donnerRecompense(client.id)
      setClient({ ...client, tampons: 0 })
    } catch (err) {
      console.error(err)
      setErreur("La carte n'a pas pu être remise à zéro. Réessaie.")
    }
    setOccupe(false)
  }

  const page = {
    minHeight: '100vh', background: SABLE, fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '1.5rem 1rem',
  }
  const bloc = { width: '100%', maxWidth: 380, background: '#fff', borderRadius: 18, padding: '1.75rem', textAlign: 'center', border: '1px solid #e8e0d8' }
  const retour = <a href="/app" style={{ marginTop: 20, fontSize: 14, color: '#888' }}>← Tableau de bord</a>

  if (etat === 'chargement') return <div style={page}><div style={{ color: '#bbb' }}>Chargement…</div></div>
  if (etat === 'introuvable') {
    return (
      <div style={page}>
        <div style={bloc}>
          <div style={{ fontSize: 40 }}>🤔</div>
          <div style={{ fontSize: 17, fontWeight: 700, color: CHARBON, marginTop: 8 }}>Mauvaise carte</div>
          <div style={{ fontSize: 15, color: '#666', marginTop: 8, lineHeight: 1.5 }}>
            Le client a montré la carte d'un autre commerce.
            Demande-lui d'ouvrir sa carte <b>{nomCommerce || 'de ton commerce'}</b> dans son Wallet,
            ou ajoute le tampon depuis le tableau de bord en cherchant son prénom.
          </div>
        </div>
        {retour}
      </div>
    )
  }

  const complete = client.tampons >= objectif
  return (
    <div style={page}>
      <div style={bloc}>
        <div style={{ fontSize: 13, color: '#999' }}>Client</div>
        <div style={{ fontSize: 28, fontWeight: 800, color: CHARBON, marginBottom: 16 }}>{client.nom}</div>

        <div style={{ display: 'flex', gap: 5, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 8 }}>
          {Array.from({ length: objectif }).map((_, i) => (
            <div key={i} style={{ width: 20, height: 20, borderRadius: 5, background: i < client.tampons ? CORAL : '#f0ece8' }} />
          ))}
        </div>
        <div style={{ fontSize: 15, color: '#888', marginBottom: 24 }}>{client.tampons}/{objectif} tampons</div>

        {complete ? (
          <>
            <div style={{ fontSize: 18, fontWeight: 700, color: CORAL, marginBottom: 16 }}>🎉 {recompense} à offrir !</div>
            <button onClick={recompenseDonnee} disabled={occupe} style={btn(CORAL)}>
              Récompense donnée → remettre à 0
            </button>
          </>
        ) : etat === 'ajoute' ? (
          <div style={{ fontSize: 18, fontWeight: 700, color: '#3B6D11' }}>✅ Tampon ajouté</div>
        ) : (
          <button onClick={plusUn} disabled={occupe} style={btn(CORAL)}>
            {occupe ? '…' : '+1 tampon'}
          </button>
        )}
        {erreur && <div style={{ color: CORAL, fontSize: 13, marginTop: 12 }}>{erreur}</div>}
      </div>
      {retour}
    </div>
  )
}

const btn = (bg) => ({
  width: '100%', background: bg, color: '#fff', border: 'none', borderRadius: 14,
  padding: '18px', fontSize: 20, fontWeight: 800, cursor: 'pointer',
})
